@if(title!='Production'){
<div class="banner">
    <div class="banner-content">
       {{title}}
    </div>
</div>
}

<div class="followups-container">
  @for(followUp of flatFollowUps;track followUp.followUpId){
      <div class="followup" [ngClass]="followUp.triggered ? 'triggered' :''">
          <div class="d-flex flex-column">
            <div class="followup-details">
                <div class="project" [ngClass]="followUp.triggered ? 'triggered' :''">{{followUp.projectName}}</div>
                <div class="flatNumber" [ngClass]="followUp.triggered ? 'triggered' :''">{{followUp.flatNumber}}</div>
                <div class="applicantName">{{followUp.applicantName}}</div>
            </div>
            @if(followUp.triggered){
              <div class="triggered-msg">Call has been triggered. Please check</div>
            }
          </div>
        <div class="followup-actions">
            <div class="call" *hasAccess="permissions.TELE_CALLING level: permissionsAcess.WRITE; hide: false" [ngClass]="followUp.triggered ? 'triggered' :'cursor-pointer'"
              (click)="!followUp.disabled ? triggerCall(followUp.followUpId,followUp.triggered): null"><i class="ph ph-phone"></i>
            </div>
            <div class="close" [ngClass]="followUp.triggered ? 'triggered' :''" (click)="dismissFollowUp(followUp.followUpId)"><i class="ph ph-x-circle"></i></div>
        </div>
      </div>
  }

  @for(activityFollowup of activityFollowups ;track activityFollowup.activityFollowUpId){
    <div class="followup">
      <div class="d-flex flex-column">
        <div class="followup-details">
          <div class="project">{{activityFollowup.projectName}}</div>
          <div class="flatNumber">{{activityFollowup.flatNumber}}</div>
          <div class="applicantName">{{activityFollowup.applicantName}}</div>
        </div>
        <div class="triggered-msg truncate-text" [matTooltip]="activityFollowup.message">{{activityFollowup.message}}</div>
      </div>
      <div class="followup-actions">
        <div class="close" (click)="dismissActivityFollowup(activityFollowup.activityFollowUpId)" (keydown.enter)="dismissActivityFollowup(activityFollowup.activityFollowUpId)"><i
            class="ph ph-x-circle"></i></div>
      </div>
    </div>
  }
</div>

<router-outlet></router-outlet>
